import { Pipe, PipeTransform } from '@angular/core';

@Pipe({ name: 'convertLinebreakToHtml' })
export class ConvertLinebreakToHtmlPipe implements PipeTransform {
    public transform(value: string): string {
        if (value) {
            return value.replace(/\n/g, '<br/>');
        }

        return '';
    }
}
